<div class="profile-container">
  <user-menu class="user-menu"></user-menu>
</div>
